import { Injectable } from "@angular/core";

import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as teacherMetricsActions from "../actions/teacher-metrics.action";

import { TeachersService } from "@carnegie-learning/data-access-angular-passport";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

@Injectable()
export class TeacherMetricsEffects {
    constructor(
        private actions$: Actions,
        private teacherService: TeachersService
    ) {}

    loadteacherMetrics$ = createEffect(() =>
        this.actions$
            .pipe(ofType(teacherMetricsActions.loadTeacherMetrics))
            // produce a side effect
            .pipe(
                map((action) => action.payload),
                switchMap((payload) => {
                    return this.teacherService.getTeacher(payload).pipe(
                        map((teacher) =>
                            teacherMetricsActions.loadTeacherMetricsSuccess({
                                payload: teacher,
                            })
                        ),
                        catchError((error) =>
                            of(
                                teacherMetricsActions.loadTeacherMetricsFail({
                                    payload: error,
                                })
                            )
                        )
                    );
                })
            )
    );
}
